import { useTranslation } from 'react-i18next';
import { LANGUAGES_MAPPER } from '@/configs/constants';

import './style.scss';

export default function SelectLanguageBtn() {
    // hooks
    const {
        t,
        i18n: { changeLanguage }
    } = useTranslation();

    // function
    const onChangeSelectLanguage = (locale: string) => {
        changeLanguage(locale);
    };

    return (
        <div className='language-switcher grid grid-cols-2 head-button-set js-slide-wall relative overflow-hidden border-[1px] border-primaryWeb rounded-button group'>
            <button
                type='button'
                className='js-left-btn h-7 w-[min(112px,19vw)] xsm:h-9 bg-[length:200%_100%] bg-[position:100%_center] group-hover:bg-[position:left_center]'
                onClick={() => onChangeSelectLanguage(LANGUAGES_MAPPER.japanese.code)}
            >
                {t(LANGUAGES_MAPPER.japanese.shortName)}
            </button>
            <button
                type='button'
                className='js-right-btn bg-[length:200%_100%] bg-[position:left_center] group-hover:bg-[position:100%_center]'
                onClick={() => onChangeSelectLanguage(LANGUAGES_MAPPER.english.code)}
            >
                {t(LANGUAGES_MAPPER.english.shortName)}
            </button>
        </div>
    );
}
